
export const typeIdToName = (typeId) => {
	switch(typeId) {
		case 9:
			return "카테고리"
		case 11:
			return "태그 검색"
		case 13:
			return "직접 입력"
		case 14:
			return "페이지"
	}
}
